// DiscussionsContext.js
import { createContext, useContext, useState } from "react";

const DiscussionsContext = createContext();

export const DiscussionsProvider = ({ children }) => {
  const [discussions, setDiscussions] = useState([]);
  const [messagesCache, setMessagesCache] = useState({});

  return (
    <DiscussionsContext.Provider value={{ discussions, setDiscussions, messagesCache, setMessagesCache }}>
      {children}
    </DiscussionsContext.Provider>
  );
};

export const useDiscussions = () => useContext(DiscussionsContext);
